import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import { getDefaultOptions } from "../../../../utils/fetch";
export const INSERT_AUDIT_REPORT_LOG = "INSERT_AUDIT_REPORT_LOG";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Reports/InsertAuditReportLog`,
    method: "POST",
     ...getDefaultOptions(),
    body: JSON.stringify(data)
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(INSERT_AUDIT_REPORT_LOG, service, mock);
